<template>
  <b-modal
    id="annonce-success-modal"
    class="full-screen-modal"
    ref="modal"
    hide-footer
    hide-header
    centered
    ok-variant="primary">
    <div>
      <div class="col-12 custom-col-12 ">
        <div id="container-title-modal" class="custom-border-bottom"><span class="page-title">{{$t("annonce.Declare.Success.Title")}}</span></div>
      </div>
      <p id="custom-p-modal" class="modal-annonce-text mt-3 mb-3" v-html="$t('annonce.Declare.Success.Text')"></p>
      <div class="row justify-content-start col-12">
        <div class="col-12">
          <div class="d-flex align-items-start">
            <i class="ph-custom ph-check-circle main-color custom-size-icon mt-1"/>
            <p class="modal-annonce-text ml-2" v-html="$t('annonce.Declare.Success.Check')"></p>
          </div>
        </div>
        <div class="col-12">
          <div class="d-flex align-items-start">
            <i class="ph-custom ph-x-circle main-red-color custom-size-icon mt-1"/>
            <p class="modal-annonce-text ml-2" v-html="$t('annonce.Declare.Fail.X')"></p>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "AnnonceSuccessModalStep0"
}
</script>

<!-- not scoped car modal --><style>
#annonce-success-modal .modal-content,
#annonce-success-modal .modal-body{
  background-color: var(--main-black-dark)!important;
  border-radius: 15px;
}

#annonce-success-modal .modal-body{
  padding: 0!important;
}

#container-title-modal , .custom-border-bottom{
  padding-bottom: 1em;
  border-bottom: 1px solid var(--main-grey-dark);
}
#custom-p-modal {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceSuccessModalStep0.vue